import { DRIVE_TAB } from "@/utils/constants/tabConstants";
import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
  Suspense,
  lazy,
  useRef,
} from "react";
import { TableTR, Button, toast } from "../../../components";
import { Loader } from "../../../components/Loader";
import { RootState, store } from "../../../store";
import {
  getListMedia,
  deleteMedia,
  updateIsFilter,
  updateIsClearFilter,
  updatePreviousFilters,
  getSearchedListMedia,
  getPresetList,
  getMedia,
  trimMedia,
} from "@/store/media/media.action";
import { TabMapping, getHeaders } from "@/utils/constants/MediaListConst";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Table } from "../../../components";
import { connect, ConnectedProps } from "react-redux";
import { RenderDescription } from "@/components/MediaList/RenderDescription";
import { RenderPublishedTo } from "@/components/MediaList/RenderPublishedTo";
import { RenderCreatedBy } from "@/components/MediaList/RenderCreatedBy";
import { RenderEngagement } from "@/components/MediaList/RenderEngagement";
import RenderStatus from "@/components/MediaList/RenderStatus";
import {
  AllHostsList,
  GetMediaApi,
  ListMediasApi,
  ProductModel,
} from "@/database";
import {
  emptyAssetDetails,
  emptyMediaDetails,
  setMediaDetails,
  setMediaList,
} from "@/store/media/media.slice";
import { setIsMediaDetailForm } from "@/store/app/app.slice";
import Modal from "@/components/Modal/Modal";
import { Tooltip } from "../../../components";
import { MediaModel } from "@/database";
import { NoContentFound } from "@/utils/ui/NoContent";
import { formatEntityName } from "@/utils/utilFunctions/entityName";
import styles from "../../../scss/media.module.scss";
import {
  copyTextToClipboard,
  formatTimestampToAgo,
  mediaStatusToTextAndColor,
  mediaStatusTooltipText,
} from "../../../utils";
import { Display_Value_Key as dvk } from "@/components/Create/utils";
import { Send, SquarePen } from "lucide-react";
import RenderAction from "@/components/MediaList/RenderAction";
import { MEDIA_STATUS } from "@/utils/constants/uiConstants";
import FilterButton from "@/utils/ui/FilterButton";
import TopFilters from "@/components/MediaList/TopFilters";
import FilterRail from "@/components/MediaList/FilterRail";
import {
  FilterSheet,
  AppliedFilterChips,
} from "@/components/MediaList/FilterSheet";
import { OPEN_MEDIA_FILTERS_EVENT } from "@/components/Header/HeaderSearch";
import { getAllowedTeamIds } from "@/utils/mediautils/mediautils";
import {
  getListAgencies,
  getBunchListData,
} from "@/store/constants/constants.action";
import { getListUser } from "@/store/user/user.action";
import { useMediaListFilters } from "@/components/MediaList/hooks/useMediaListFilters";
import { useMediaListAutoSelect } from "@/components/MediaList/hooks/useMediaListAutoSelect";
import { trackEvent, getTrackUserContext } from "@/utils/analytics";

// Lazy load heavy components
const GeneralPlayerWrapper = lazy(
  () => import("../../../components/Player/GeneralPlayerWrapper")
);
const MediaDetails = lazy(() => import("../../pages/MediaDetail/MediaDetails"));
const MediaPublish = lazy(
  () => import("../../pages/MediaPublish/MediaPublish")
);
const VideoTrimmer = lazy(
  () => import("../../../components/VideoTrimmer/VideoTrimmer")
);

// Module-level guard to prevent duplicate getMedia calls (e.g. React Strict Mode double-invoke)
let pendingChopperIdForTrim: string | null = null;

const COUNT_IGNORED_FILTER_KEYS = new Set([
  "page",
  "rows",
  "sort",
  "sortBy",
  "must_not",
]);

function countAppliedFilters(filters: Record<string, any>): number {
  let count = 0;
  Object.keys(filters).forEach((key) => {
    if (key.endsWith(dvk)) return;
    if (COUNT_IGNORED_FILTER_KEYS.has(key)) return;
    const value = filters[key];
    if (value == null) return;
    if (Array.isArray(value) && value.length === 0) return;
    count += 1;
  });
  // Collapse the composite uploaded-by filter (ctby/team/must_not) into one.
  const hasUploadedComposite =
    filters.ctby != null || filters.team != null || filters.must_not != null;
  if (hasUploadedComposite) {
    const individualUploadedCount =
      (filters.ctby != null ? 1 : 0) + (filters.team != null ? 1 : 0);
    if (individualUploadedCount > 1) {
      count -= individualUploadedCount - 1;
    }
  }
  return count;
}

const MediaList = ({
  isLoading,
  getListMedia,
  getSearchedListMedia,
  mediaList,
  categoriesConst,
  languageConst,
  mediaListCount,
  orgBusTeamConstants,
  limit,
  users,
  singleCurrentUser,
  setMediaDetails,
  setMediaList,
  updateIsFilter,
  isFilter,
  isClearFilter,
  updateIsClearFilter,
  denmarkHosts,
  emptyMediaDetails,
  emptyAssetDetails,
  currentMediaDetailsForEdit,
  getMedia,
  presetList,
  preMediaList,
  trimMedia,
  postMediaList,
  hosts,
  getListAgencies,
  getListUser,
  agenciesList,
  getBunchListData,
  bunchBusinessList,
  bunchProductList,
  bunchBusinessListLoading,
  bunchProductListLoading,
  allHostsList,
  defaultTeam,
  cameFromMediaDetailForm,
  setIsMediaDetailForm,
}: Props) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [localIsLoading, setLocalIsLoading] = useState(true);
  const [isNavTabsDisabled, setIsNavTabsDisabled] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalContent, setModalContent] = useState<React.ReactNode | null>(
    null
  );
  const [currentMedia, setCurrentMedia] = useState<MediaModel | null>(null);
  const [isMediaModalOpen, setIsMediaModalOpen] = useState<boolean>(false);
  const [isSocialModalOpen, setIsSocialModalOpen] = useState<boolean>(false);
  const [socialPublishMediaId, setSocialPublishMediaId] = useState<string>("");
  const [footerBtnContent, setFooterBtnContent] =
    useState<string>("Save & Next");
  const [clonedMedia, setClonedMedia] = useState<MediaModel | null>(null);
  const [isTrimmerOpen, setIsTrimmerOpen] = useState<boolean>(false);
  const [trimmerMedia, setTrimmerMedia] = useState<MediaModel | null>(null);
  const [isTrimmerFromChopper, setIsTrimmerFromChopper] =
    useState<boolean>(false);
  const [isWaitingForMedia, setIsWaitingForMedia] = useState<boolean>(false);
  const [isCloneInitiated, setIsCloneInitiated] = useState<boolean>(false);
  const [dropdownStates, setDropdownStates] = useState<Record<string, boolean>>(
    {}
  );

  // Returning from the media detail form with a non-empty cached list means
  // this exact list was already fetched right before navigating away — skip
  // the redundant refetch and just render what's cached. Captured once at
  // mount (not recomputed on re-render) and consumed on the first render
  // pass; an empty cache (e.g. first visit this session) always refetches
  // so the page never gets stuck showing nothing.
  const skipInitialFetchRef = useRef(
    cameFromMediaDetailForm && mediaList.length > 0
  );
  useEffect(() => {
    if (cameFromMediaDetailForm) {
      setIsMediaDetailForm(false);
    }
    if (skipInitialFetchRef.current) {
      // A stale in-flight fetch from before navigating away may have left
      // this true; since we're skipping the refetch, clear it so the table
      // doesn't render a skeleton forever.
      setMediaList({ isLoading: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getListMediaGated = useCallback(
    (params: any) => {
      if (skipInitialFetchRef.current) {
        skipInitialFetchRef.current = false;
        return;
      }
      return getListMedia(params);
    },
    [getListMedia]
  );

  // Ref to track if we've already processed a chopperId
  const processedChopperIdRef = useRef<string | null>(null);
  // Ref to prevent reopening after close
  const isClosingTrimmerRef = useRef<boolean>(false);
  // Ref to remember the wizard modal was opened from a chopper trim, so the
  // "source=chopper" filter can be restored on the URL when the modal closes
  const wasChopperTrimRef = useRef<boolean>(false);

  const [activeType, setActiveType] = useState<string>(() => {
    const pathname = window.location.pathname;
    const tabParam = searchParams.get("tab");

    if (tabParam) {
      return tabParam;
    }

    if (pathname.startsWith("/drive")) {
      return DRIVE_TAB;
    }

    const assetTypeFromPath = pathname.split("/").pop();
    if (assetTypeFromPath) {
      if (Object.keys(TabMapping).includes(assetTypeFromPath)) {
        return assetTypeFromPath;
      }
    }
    return "video";
  });

  const [isFilterSheetOpen, setIsFilterSheetOpen] = useState<boolean>(false);

  // Listen for the global header's filter shortcut. The header dispatches a
  // window event rather than importing this page, keeping the dependency
  // one-way and avoiding a Redux flag for a single ephemeral signal.
  useEffect(() => {
    const open = () => setIsFilterSheetOpen(true);
    window.addEventListener(OPEN_MEDIA_FILTERS_EVENT, open);
    return () => window.removeEventListener(OPEN_MEDIA_FILTERS_EVENT, open);
  }, []);

  // Use the custom filters hook
  const {
    filters,
    setFilters,
    hiddenFilter,
    setHiddenFilter,
    availableFilters,
    handleSetFilters,
    handleSortChange,
    updateFiltersAndLoadingCallback,
    emptyHiddenFilter,
  } = useMediaListFilters({
    updateIsFilter,
    setLocalIsLoading,
    activeType,
    setActiveType,
    orgBusTeamConstants,
    categoriesConst,
    languageConst,
    users,
    singleCurrentUser,
    bunchProductList,
    agenciesList,
    bunchBusinessList,
  });

  // Use the custom auto-select hook
  const { onAutoSelectInputChange, autoSelectOptionsMap } =
    useMediaListAutoSelect({
      filters,
      getListAgencies,
      getListUser,
      singleCurrentUser,
    });
  const getWizardModalTitle = () => {
    if (isCloneInitiated) {
      return "Create Clone";
    }
    if (currentMediaDetailsForEdit?.media_ref?.rel) {
      switch (currentMediaDetailsForEdit.media_ref.rel.toLowerCase()) {
        case "clone":
          return "Create Clone";
        case "simulive":
          return "Create Simulive";
        case "podcast":
          return "Create Podcast";
        case "embed":
          return "Embed Content";
        case "trimmed":
          return "Edit Content";
        default:
          return "Upload Content";
      }
    }
    return "Upload Content";
  };

  const handleClose = () => {
    if (clonedMedia?.status !== -99) {
      updateIsClearFilter(true);
      updateIsFilter(false);
      const assetType = clonedMedia?.asset_type;
      const isDriveAsset =
        assetType === "library" ||
        (assetType === "video" && clonedMedia?.content_type === 2);
      const targetPath = wasChopperTrimRef.current
        ? assetType === "shorts"
          ? "/media/shorts?source=chopper"
          : "/media/video?source=chopper"
        : isDriveAsset
          ? "/drive/video"
          : `/media/${assetType}`;
      try {
        navigate(targetPath);
      } catch (error) {
        console.error("testing clone::Navigation failed:", error);
      }
    }
    wasChopperTrimRef.current = false;
    setIsMediaModalOpen(false);
    setIsSocialModalOpen(false);
    setSocialPublishMediaId("");
    setIsCloneInitiated(false);
    emptyMediaDetails();
    emptyAssetDetails();
    setClonedMedia(null);
    setFooterBtnContent("Save & Next");
  };

  console.log("checking the filers here-------->", filters, hiddenFilter);

  useEffect(() => {
    const alreadyLoaded =
      (bunchBusinessList?.length ?? 0) > 0 &&
      (bunchProductList?.length ?? 0) > 0;
    if (
      !alreadyLoaded &&
      !bunchBusinessListLoading &&
      !bunchProductListLoading
    ) {
      getBunchListData({
        keys: [
          "business",
          "team",
          "all_business_team",
          "language",
          "category",
          "source",
        ],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDropdownStateChange = useCallback(
    (mediaId: string, isOpen: boolean) => {
      setDropdownStates((prev) => ({
        ...prev,
        [mediaId]: isOpen,
      }));
    },
    []
  );
  const handlePreviewModalClose = useCallback(() => {
    setIsModalOpen(false);
    setCurrentMedia(null);
    setModalContent(null);
  }, []);

  const handleRequestTrim = useCallback(
    (media: MediaModel) => {
      handlePreviewModalClose();
      setTrimmerMedia(media);
      setIsTrimmerFromChopper(false);
      setIsTrimmerOpen(true);
    },
    [handlePreviewModalClose]
  );

  useEffect(() => {
    if (defaultTeam && defaultTeam?.settings?.host) {
      let hostId = defaultTeam?.settings?.host;
      if (hostId === "none") {
        hostId = "";
      }
    }
  }, [defaultTeam]);

  // Handle chopperId query parameter
  useEffect(() => {
    const chopperId = searchParams.get("chopperId");

    if (limit) {
      if (chopperId) {
        navigate(`/drive/video?${searchParams.toString()}`, { replace: true });
      }
      return;
    }

    if (!chopperId) {
      isClosingTrimmerRef.current = false;
      return;
    }

    // Only process if we haven't processed this specific ID yet
    if (chopperId !== processedChopperIdRef.current) {
      // Check if we're not in the middle of closing
      if (isClosingTrimmerRef.current) {
        return;
      }
      // Skip if a request for this chopperId is already in flight (e.g. Strict Mode double-invoke)
      if (pendingChopperIdForTrim === chopperId) {
        return;
      }

      pendingChopperIdForTrim = chopperId;
      processedChopperIdRef.current = chopperId;
      setIsWaitingForMedia(true);

      GetMediaApi({ id: chopperId })
        .then((initialResponse) => {
          if (isClosingTrimmerRef.current) {
            return;
          }
          const initialMediaData = initialResponse?.data;
          const driveTargetType =
            initialMediaData?.asset_type === "shorts" ? "shorts" : "video";

          setFilters((prev) => {
            const next = { ...prev };
            next.source = ["chopper"];
            next["sourcedisplayValue"] = "chopper";
            return next;
          });
          setHiddenFilter({ asset_type: driveTargetType, content_type: 2 });
          setActiveType(DRIVE_TAB);
          navigate(`/drive/${driveTargetType}?chopperId=${chopperId}`, {
            replace: true,
          });

          const trimmedChild = Array.isArray(initialMediaData?.child_media)
            ? initialMediaData.child_media.find(
                (c: { type?: string }) => c.type === "trimmed"
              )
            : null;
          if (trimmedChild) {
            setIsWaitingForMedia(false);
            isClosingTrimmerRef.current = true;
            processedChopperIdRef.current = null;
            pendingChopperIdForTrim = null;
            navigate(`/media/${chopperId}/details?tab=drive`);
            return;
          }

          if (initialMediaData?.localpreviewfile) {
            setTrimmerMedia(initialMediaData);
            setIsTrimmerFromChopper(true);
            setIsTrimmerOpen(true);
            setIsWaitingForMedia(false);
          } else {
            setIsWaitingForMedia(false);
            processedChopperIdRef.current = null;
            pendingChopperIdForTrim = null;
            toast.fail("Media not ready for trimming. Please try again.");
          }
        })
        .catch((error) => {
          console.error("Failed to fetch media for trimmer:", error);
          toast.fail("Failed to load media for trimming");
          processedChopperIdRef.current = null;
          pendingChopperIdForTrim = null;
          setIsWaitingForMedia(false);
        });
    }
  }, [searchParams, getMedia, navigate, setFilters, setHiddenFilter, limit]);

  // Re-apply the chopper source filter when returning from the wizard modal
  // after a chopper trim (see wasChopperTrimRef / handleClose). Gated on
  // activeType being the tab the trim landed on ("video" or "shorts") so this
  // runs after useMediaListFilters' own tab-switch effect has reset `filters`
  // for the new activeType — otherwise that reset clobbers the filter we set here.
  // Applies the filter to internal state only, once — it does NOT strip
  // `source` back out of the URL, since doing so via navigate() raced with
  // other URL-driven effects and caused an infinite update loop.
  const appliedChopperSourceRef = useRef(false);
  useEffect(() => {
    const hasChopperSource = searchParams.get("source") === "chopper";
    if (!hasChopperSource) {
      appliedChopperSourceRef.current = false;
      return;
    }
    if (
      appliedChopperSourceRef.current ||
      (activeType !== "video" && activeType !== "shorts")
    ) {
      return;
    }
    appliedChopperSourceRef.current = true;
    setFilters((prev) => {
      const next = { ...prev };
      next.source = ["chopper"];
      next["sourcedisplayValue"] = "chopper";
      return next;
    });
  }, [searchParams, setFilters, activeType]);

  // Function to remove chopperId from URL
  const removeChopperIdFromUrl = useCallback(() => {
    isClosingTrimmerRef.current = true;
    processedChopperIdRef.current = null;
    pendingChopperIdForTrim = null;
    setIsWaitingForMedia(false);
    setFilters((prev) => {
      const next = { ...prev };
      delete next.chopperId;
      return next;
    });
    const currentParams = new URLSearchParams(searchParams);
    if (currentParams.has("chopperId")) {
      currentParams.delete("chopperId");
      const newUrl = currentParams.toString()
        ? `${window.location.pathname}?${currentParams.toString()}`
        : window.location.pathname;
      navigate(newUrl, { replace: true });
    }
  }, [searchParams, navigate]);

  const isFirstActiveTypeEffectRef = useRef(true);
  useEffect(() => {
    // On the very first mount, skip this reset if we're intentionally
    // reusing the cached list from before navigating to the detail form —
    // otherwise this unconditionally wipes the data getListMediaGated just
    // decided not to refetch, leaving the table stuck empty forever.
    if (isFirstActiveTypeEffectRef.current) {
      isFirstActiveTypeEffectRef.current = false;
      if (skipInitialFetchRef.current) {
        return;
      }
    }
    setMediaList({ data: { list: [], count: 0 }, isLoading: true, error: "" });
    setLocalIsLoading(true);
  }, [activeType]); // Removed setMediaList from dependencies as it's a stable Redux action

  // Handle initial page load - redirect if URL has filters but missing asset type
  useEffect(() => {
    const pathname = window.location.pathname;

    const tabParam = searchParams.get("tab");

    searchParams.delete("tab");
    // Check if we're on /media without a specific asset type but have filters
    if (pathname === "/media" && searchParams) {
      // Redirect to /media/video with the existing filters
      const targetPath = `/media/${
        tabParam ? tabParam : "video"
      }?${searchParams}`;
      navigate(targetPath, { replace: true });
    }
  }, []);

  const handleMediaPreviewModalOpen = useCallback(
    (media: MediaModel) => {
      trackEvent("browse", {
        category: "content",
        entity: "Preview",
        action: "click",
        channel: singleCurrentUser?.business || "",
        product: singleCurrentUser?.team || "",
        userId: singleCurrentUser?.id || "",
        location:
          typeof window !== "undefined" &&
          window.location.pathname.startsWith("/discover")
            ? "discover"
            : "content",
        ...getTrackUserContext(),
      });

      setModalContent(
        <GeneralPlayerWrapper
          media={media}
          currentTab={activeType}
          showUsedBy={activeType === DRIVE_TAB ? true : false}
          hosts={hosts}
        />
      );
      setCurrentMedia(media);
      setMediaDetails({ data: { media: media } });
      setIsModalOpen(true);
    },
    [activeType, hosts, setMediaDetails]
  );

  const handleTabChange = useCallback(
    (filter: string) => {
      if (isNavTabsDisabled) {
        return;
      }
      // setMediaList({ data: { list: [], count: 0 }, isLoading: true, error: '' });

      if (filter === "drive-video" || filter === "drive-shorts") {
        setHiddenFilter({
          asset_type: filter === "drive-shorts" ? "shorts" : "video",
          content_type: 2,
        });
        setActiveType(DRIVE_TAB);
        setLocalIsLoading(true);
        navigate(
          {
            pathname:
              filter === "drive-shorts" ? "/drive/shorts" : "/drive/video",
            search: "",
          },
          { replace: true }
        );
        return;
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const premiereFilter: any =
        filter === "premiere"
          ? { asset_type: "video", ctype: ["premiere"] }
          : filter === DRIVE_TAB
            ? { asset_type: "video", content_type: 2 }
            : filter === "video"
              ? {
                  asset_type: ["video", "campaign", "slates"],
                  must_not: { ctype: ["premiere"], content_type: 2 },
                }
              : {
                  asset_type: filter,
                  must_not: { ctype: ["premiere"], content_type: 2 },
                };
      setHiddenFilter(premiereFilter);
      setActiveType(filter);
      setLocalIsLoading(true);

      navigate(
        {
          pathname: filter === DRIVE_TAB ? "/drive/video" : `/media/${filter}`,
          search: "",
        },
        { replace: true }
      );
    },
    [
      isNavTabsDisabled,
      navigate,
      setHiddenFilter,
      setActiveType,
      setLocalIsLoading,
    ]
  );

  const handleNextClick = useCallback(() => {
    const event = new Event("nextClick");
    window.dispatchEvent(event);
  }, []);

  const handleBackClick = useCallback(() => {
    if (socialPublishMediaId) {
      getMedia({ id: socialPublishMediaId });
      setIsSocialModalOpen(false);
      setIsMediaModalOpen(true);
    }
  }, [socialPublishMediaId, getMedia]);

  const handleDone = () => {
    // Dispatching "doneClick" triggers MediaPublish's own handleDone, which
    // already calls closeHandler (= handleClose) after its own cleanup.
    // Calling handleClose() here too would invoke it twice; the second call
    // would see wasChopperTrimRef already cleared by the first, dropping the
    // chopper redirect (source=chopper) on the way out.
    const event = new CustomEvent("doneClick");
    window.dispatchEvent(event);
  };

  const getProductNameById = useCallback(
    (productId: string) => {
      if (!productId) return "--";

      const productItem = bunchProductList?.find(
        (p: ProductModel) => p.id === productId
      );
      return productItem?.name || productId;
    },
    [bunchProductList]
  );

  const handleModalClose = useCallback(() => {
    setModalContent(null);
    setIsModalOpen(false);
    setCurrentMedia(null);
    setMediaDetails({});
  }, [setMediaDetails]);

  const handleMediaEdit = useCallback(() => {
    console.log("inside the handleMediaEdit");
    if (currentMedia?.id) {
      setMediaDetails({ data: { media: currentMedia } });
      handleModalClose();
      const returnTab =
        activeType === "premiere"
          ? "?tab=premiere"
          : activeType === DRIVE_TAB
            ? "?tab=video"
            : "";
      navigate(`/media/${currentMedia?.id}/details${returnTab}`);
    }
  }, [activeType, currentMedia, handleModalClose, navigate, setMediaDetails]);

  const handleSocialPublish = useCallback(() => {
    if (currentMedia?.id) {
      setMediaDetails({ data: { media: currentMedia } });
      handleModalClose();
      navigate(`/media/${currentMedia?.id}/social-publish`);
    }
  }, [currentMedia, handleModalClose, navigate, setMediaDetails]);

  useEffect(() => {
    if (mediaList.length > 0 || mediaListCount === 0) {
      setLocalIsLoading(false);
    }
  }, [mediaList, mediaListCount, isLoading]);

  useEffect(() => {
    if (limit || isLoading) return;

    const currentPage = Number(filters?.page);
    if (!Number.isFinite(currentPage) || currentPage <= 1) return;

    const rows = Number(filters?.rows) || 30;
    const maxPage = Math.max(1, Math.ceil(mediaListCount / rows));

    if (currentPage > maxPage) {
      updateFiltersAndLoadingCallback({ ...filters, page: 1 });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mediaListCount, isLoading, limit]);

  // Add 100ms delay after isLoading becomes false before enabling nav tabs
  useEffect(() => {
    if (!isLoading) {
      const timer = setTimeout(() => {
        setIsNavTabsDisabled(false);
      }, 400);
      return () => clearTimeout(timer);
    } else {
      setIsNavTabsDisabled(true);
    }
  }, [isLoading]);

  return (
    <>
      {isMediaModalOpen && (
        <Modal
          isOpen={isMediaModalOpen}
          title={getWizardModalTitle()}
          onClose={() => {
            handleClose();
          }}
          width="100%"
          closeOnOutsideClick={false}
          height="100vh"
          footer={<Button onClick={handleNextClick}>{footerBtnContent}</Button>}
        >
          <Suspense
            fallback={
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "400px" }}
              >
                Loading...
              </div>
            }
          >
            <MediaDetails
              isWizard={true}
              closeHandler={() => {
                handleClose();
              }}
              closeModal={handleClose}
              openPublish={() => {
                updateIsClearFilter?.(true);
                updateIsFilter?.(false);
                if (currentMediaDetailsForEdit?.id) {
                  setSocialPublishMediaId(currentMediaDetailsForEdit.id);
                }
                setIsMediaModalOpen(false);
                setIsSocialModalOpen(true);
              }}
            />
          </Suspense>
        </Modal>
      )}
      {isWaitingForMedia && <Loader minusTopSection="0" />}
      {isTrimmerOpen && trimmerMedia && (
        <Suspense
          fallback={
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "400px" }}
            >
              Loading...
            </div>
          }
        >
          <VideoTrimmer
            isOpen={isTrimmerOpen}
            onClose={() => {
              removeChopperIdFromUrl();
              setIsTrimmerOpen(false);
              setTrimmerMedia(null);
              setIsTrimmerFromChopper(false);
            }}
            media={trimmerMedia}
            onTrimComplete={(trimmedMedia: MediaModel) => {
              wasChopperTrimRef.current = isTrimmerFromChopper;
              removeChopperIdFromUrl();
              setIsTrimmerOpen(false);
              setTrimmerMedia(null);
              setIsTrimmerFromChopper(false);
              if (trimmedMedia && trimmedMedia.id) {
                setClonedMedia(trimmedMedia);
                setMediaDetails({ data: { media: trimmedMedia } });
                setIsMediaModalOpen(true);
              }
            }}
            trimMedia={trimMedia}
            updateModal={() => {}}
            presetList={presetList}
            preMediaList={preMediaList}
            postMediaList={postMediaList}
            getListMedia={getListMedia}
            getSearchedListMedia={getSearchedListMedia}
            getPresetList={getPresetList}
            getMedia={getMedia}
            currentTab={activeType}
            isChopperFlow={isTrimmerFromChopper}
          />
        </Suspense>
      )}
      {isSocialModalOpen && (
        <Modal
          isOpen={isSocialModalOpen}
          title="Social Publish"
          onClose={() => {
            handleClose();
          }}
          height="100vh"
          width="100%"
          closeOnOutsideClick={false}
          footer={
            <div className="d-flex justify-content-between w-100">
              <Button type="outline-primary" onClick={handleBackClick}>
                Back
              </Button>
              <Button onClick={handleDone}>Done</Button>
            </div>
          }
        >
          <Suspense
            fallback={
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "400px" }}
              >
                Loading...
              </div>
            }
          >
            <MediaPublish
              isWizard={true}
              closeHandler={() => {
                handleClose();
              }}
            />
          </Suspense>
        </Modal>
      )}
      <TopFilters
        limit={limit}
        activeType={activeType}
        isNavTabsDisabled={isNavTabsDisabled}
        filters={filters}
        onTabChange={handleTabChange}
        onSortChange={handleSortChange}
      />
      {!limit && (
        <FilterRail
          isOpen={isFilterSheetOpen}
          count={countAppliedFilters(filters)}
          onToggle={() => setIsFilterSheetOpen((v) => !v)}
        />
      )}
      {!limit && (
        <AppliedFilterChips
          appliedFilters={filters}
          availableFilters={availableFilters}
          onRemove={(next) => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            updateFiltersAndLoadingCallback(next);
          }}
          onClearAll={() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            updateIsClearFilter(true);
          }}
          onOpenSheet={() => setIsFilterSheetOpen(true)}
          singleCurrentUser={singleCurrentUser}
        />
      )}
      {!limit && (
        <FilterSheet
          show={isFilterSheetOpen}
          onHide={() => setIsFilterSheetOpen(false)}
          availableFilters={availableFilters}
          appliedFilters={filters}
          onApply={(next) => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            updateFiltersAndLoadingCallback(next);
          }}
          onClear={() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            updateIsClearFilter(true);
          }}
          allowedTeamIds={getAllowedTeamIds(singleCurrentUser?.permissions)}
          onAutoSelectInputChange={onAutoSelectInputChange}
          autoSelectOptionsMap={autoSelectOptionsMap}
          autoSelectLoader={true}
          currentUser={singleCurrentUser}
          getProductNameById={getProductNameById}
        />
      )}
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          title={currentMedia?.title || ""}
          closeOnOutsideClick={true}
          width="990px"
          footer={
            <div className="d-flex justify-content-between w-100">
              <div className="d-flex align-items-center gap-2 text-muted">
                {currentMedia?.content_type !== 2 && (
                  <div className="d-flex align-items-center gap-1">
                    {currentMedia?.media_status ===
                      MEDIA_STATUS.MEDIA_STATUS_DRAFT ||
                    currentMedia?.media_status ===
                      MEDIA_STATUS.MEDIA_STATUS_PUBLISHING ? (
                      <Tooltip
                        content={mediaStatusTooltipText(
                          currentMedia?.media_status || 0
                        )}
                      >
                        <span
                          className={`badge ${
                            mediaStatusToTextAndColor(
                              currentMedia?.media_status || 0
                            ).statusColor
                          }`}
                        >
                          {
                            mediaStatusToTextAndColor(
                              currentMedia?.media_status || 0
                            ).statusText
                          }
                        </span>
                      </Tooltip>
                    ) : currentMedia?.media_status ===
                        MEDIA_STATUS.MEDIA_STATUS_INACTIVE ||
                      currentMedia?.media_status ===
                        MEDIA_STATUS.MEDIA_STATUS_PUBLISHED ? (
                      <>
                        <Tooltip
                          content={mediaStatusTooltipText(
                            currentMedia?.media_status || 0
                          )}
                        >
                          <span
                            className={`badge ${
                              mediaStatusToTextAndColor(
                                currentMedia?.media_status || 0
                              ).statusColor
                            }`}
                          >
                            {
                              mediaStatusToTextAndColor(
                                currentMedia?.media_status || 0
                              ).statusText
                            }
                          </span>
                        </Tooltip>
                        {activeType !== DRIVE_TAB && (
                          <Tooltip content="Copy ID">
                            <div
                              className={`slike-id rounded badge fs-6 ${styles["hover-filter"]}`}
                              onClick={async (e) => {
                                e.stopPropagation();
                                trackEvent("browse", {
                                  category: "content",
                                  entity: "Slike ID",
                                  action: "copy",
                                  location:
                                    typeof window !== "undefined" &&
                                    window.location.pathname.startsWith(
                                      "/discover"
                                    )
                                      ? "discover"
                                      : "content",
                                  ...getTrackUserContext(),
                                });
                                await copyTextToClipboard(currentMedia.id);
                                toast.success("Slike ID copied");
                              }}
                            >
                              {currentMedia.id}
                            </div>
                          </Tooltip>
                        )}
                      </>
                    ) : (
                      <Tooltip
                        content={mediaStatusTooltipText(
                          currentMedia?.media_status || 0
                        )}
                      >
                        <span
                          className={`badge ${
                            mediaStatusToTextAndColor(
                              currentMedia?.media_status || 0
                            ).statusColor
                          }`}
                        >
                          {
                            mediaStatusToTextAndColor(
                              currentMedia?.media_status || 0
                            ).statusText
                          }
                        </span>
                      </Tooltip>
                    )}
                  </div>
                )}
                <div>{`${formatTimestampToAgo(currentMedia?.ct || 0)} | ${
                  currentMedia?.ctbydata?.name
                }`}</div>
              </div>
              <div className="d-flex gap-3">
                {activeType !== DRIVE_TAB &&
                (currentMedia?.media_status ===
                  MEDIA_STATUS.MEDIA_STATUS_DRAFT ||
                  currentMedia?.media_status ===
                    MEDIA_STATUS.MEDIA_STATUS_PUBLISHING) ? (
                  <div className="" onClick={handleMediaEdit}>
                    <Button type="primary" onClick={handleMediaEdit}>
                      <SquarePen size={14} /> Edit
                    </Button>
                  </div>
                ) : (
                  <>
                    {activeType === DRIVE_TAB ? (
                      currentMedia?.media_status ===
                        MEDIA_STATUS.MEDIA_STATUS_PUBLISHED ||
                      currentMedia?.media_status ===
                        MEDIA_STATUS.MEDIA_STATUS_INACTIVE ? (
                        <RenderAction
                          media={currentMedia}
                          paramFilter={searchParams}
                          tab={activeType}
                          setIsMediaModalOpen={setIsMediaModalOpen}
                          setIsSocialModalOpen={setIsSocialModalOpen}
                          setFooterBtnContent={setFooterBtnContent}
                          setClonedMedia={setClonedMedia}
                          onPreviewModalClose={handlePreviewModalClose}
                          onRequestTrim={handleRequestTrim}
                          onCloneInitiated={() => setIsCloneInitiated(true)}
                          showCtaText={true}
                          fromLibraryPreview={true}
                          libraryCtaOrd={["send", "clone", "trim"]}
                        />
                      ) : (
                        <Button type="primary" onClick={handleMediaEdit}>
                          <SquarePen size={14} /> Edit
                        </Button>
                      )
                    ) : currentMedia?.media_status ===
                        MEDIA_STATUS.MEDIA_STATUS_PUBLISHED ||
                      currentMedia?.media_status ===
                        MEDIA_STATUS.MEDIA_STATUS_INACTIVE ? (
                      <>
                        <Button
                          type="outline-primary"
                          onClick={handleSocialPublish}
                        >
                          <Send size={14} /> Social
                        </Button>
                        <Button type="primary" onClick={handleMediaEdit}>
                          <SquarePen size={14} /> Edit
                        </Button>
                      </>
                    ) : null}
                  </>
                )}
              </div>
            </div>
          }
        >
          <Suspense
            fallback={
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "400px" }}
              >
                Loading...
              </div>
            }
          >
            {modalContent}
          </Suspense>
        </Modal>
      )}
      <Table
        columns={getHeaders(activeType)}
        page="media"
        totalCount={limit ? 0 : mediaListCount}
        availableFilters={limit ? [] : availableFilters}
        appliedFilters={filters}
        isLoading={isLoading}
        isFilter={isFilter}
        ListMediaApi={ListMediasApi}
        downloadCsv={!limit}
        handleSetFilters={handleSetFilters}
        filters={filters}
        isClearFilter={isClearFilter}
        getListMedia={getListMediaGated}
        isSetinParams={!limit}
        hiddenFilters={hiddenFilter}
        setHiddenFilters={setHiddenFilter}
        emptyHiddenFilter={emptyHiddenFilter}
        limit={limit ? true : false}
        minHiddenFilters={1}
        showSortBy={true}
        showFilters={false}
        rowsPerPageOptions={[10, 30, 50, 100]}
        minRowsPerPage={30}
        autoSelectLoader={true}
        onAutoSelectInputChange={onAutoSelectInputChange}
        autoSelectOptionsMap={autoSelectOptionsMap}
      >
        {useMemo(() => {
          if (mediaList.length === 0) {
            return (
              <TableTR rowKey="no-content">
                <td colSpan={getHeaders(activeType).length}>
                  <NoContentFound message="No Content Found" fill />
                </td>
              </TableTR>
            );
          }

          const listToRender = limit ? mediaList.slice(0, limit) : mediaList;
          return listToRender.map((media: MediaModel, rowIndex: number) => (
            <TableTR
              key={media.id || `media-${rowIndex}`}
              rowKey={media.id || `media-${rowIndex}`}
              className={
                dropdownStates[media.id] ? styles["dropdown-open"] : ""
              }
            >
              <td width="40%">
                <RenderDescription
                  media={media}
                  onMediaPreview={() => handleMediaPreviewModalOpen(media)}
                  filters={filters}
                  updateIsFilter={updateIsFilter}
                  updateIsClearFilter={updateIsClearFilter}
                  handleSetFilters={handleSetFilters}
                  useProgressiveLoading={true}
                  tab={activeType}
                  setIsMediaModalOpen={setIsMediaModalOpen}
                  setIsSocialModalOpen={setIsSocialModalOpen}
                  setFooterBtnContent={setFooterBtnContent}
                  setClonedMedia={setClonedMedia}
                  onCloneInitiated={() => setIsCloneInitiated(true)}
                  isDropdownOpen={dropdownStates[media.id] || false}
                  onDropdownStateChange={(isOpen: boolean) =>
                    handleDropdownStateChange(media.id, isOpen)
                  }
                />
              </td>
              <td width="12%">
                <RenderCreatedBy
                  media={media}
                  filters={filters}
                  updateIsFilter={updateIsFilter}
                  updateIsClearFilter={updateIsClearFilter}
                  handleSetFilters={handleSetFilters}
                />
              </td>
              <td width="12%">
                <div className="d-flex flex-column gap-1">
                  <div
                    className={`d-flex flex-column ${styles["hover-filter"]}`}
                  >
                    <div className="">
                      <span className="text-primary fw-medium">
                        {formatEntityName(media?.teamdata) || "--"}
                      </span>
                      {media?.team !== null && media?.team !== undefined && (
                        <FilterButton
                          filterKey="team"
                          filterValue={media?.team}
                          displayText={
                            formatEntityName(media?.teamdata) || "--"
                          }
                          filters={filters}
                          updateIsFilter={updateIsFilter}
                          updateIsClearFilter={updateIsClearFilter}
                          handleSetFilters={handleSetFilters}
                          dvk={dvk}
                          filterDisplayName="Team"
                          useContentEvent
                        />
                      )}
                    </div>
                  </div>
                  <div
                    className={`d-flex flex-column ${styles["hover-filter"]}`}
                  >
                    <small className="text-uppercase">Agency:</small>
                    <div className="">
                      <span className="text-primary fw-medium">
                        {formatEntityName(media?.agencydata) || "--"}
                      </span>
                      {media?.agency !== null &&
                        media?.agency !== undefined && (
                          <FilterButton
                            filterKey="agency"
                            filterValue={media?.agency}
                            displayText={
                              formatEntityName(media?.agencydata) || "--"
                            }
                            filters={filters}
                            updateIsFilter={updateIsFilter}
                            updateIsClearFilter={updateIsClearFilter}
                            handleSetFilters={handleSetFilters}
                            dvk={dvk}
                            filterDisplayName="Agency"
                            useContentEvent
                          />
                        )}
                    </div>
                  </div>
                </div>
              </td>
              {activeType !== DRIVE_TAB && (
                <td className={styles["hover-filter"]} width="10%">
                  <RenderStatus
                    media={media}
                    activeType={activeType}
                    filters={filters}
                    updateIsFilter={updateIsFilter}
                    updateIsClearFilter={updateIsClearFilter}
                    handleSetFilters={handleSetFilters}
                  />
                </td>
              )}

              <td width="16%" className="published-to-cell">
                <RenderPublishedTo
                  media={media}
                  allHostsList={allHostsList}
                  activeType={activeType}
                  getProductNameById={getProductNameById}
                  hosts={hosts}
                  denmarkHosts={denmarkHosts}
                />
              </td>
              {activeType !== DRIVE_TAB && (
                <td width="16%">
                  <RenderEngagement
                    media={media}
                    paramFilter={searchParams}
                    tab={activeType}
                  />
                </td>
              )}
            </TableTR>
          ));
        }, [
          mediaList,
          limit,
          activeType,
          dropdownStates,
          filters,
          handleMediaPreviewModalOpen,
          handleSetFilters,
          handleDropdownStateChange,
          updateIsFilter,
          updateIsClearFilter,
          getProductNameById,
          hosts,
          denmarkHosts,
          searchParams,
          setIsMediaModalOpen,
          setIsSocialModalOpen,
          setFooterBtnContent,
          setClonedMedia,
        ])}
      </Table>
    </>
  );
};

const mapState = (state: RootState) => ({
  isLoading: state.media.mediaList.isLoading,
  mediaList: state.media.mediaList.list,
  mediaListCount: state.media.mediaList.count,
  cameFromMediaDetailForm: state.app.isMediaDetailForm,
  currentMediaDetailsForEdit: state.media.mediaDetails.media,
  categoriesConst: state.app.categories,
  languageConst: state.app.metaLanguage,

  orgBusTeamConstants: state.app.orgBusTeamConstants,
  users: state.app.constUserList,
  singleCurrentUser: state.users.singleCurrentUser,

  mostFrequentUsers: state.users.mostFrequentUsers,
  isFilter: state.media.isFilter,
  isClearFilter: state.media.isClearFilter,
  hosts: state.media.hostList.list,
  categories: state.app.categories,
  language: state.app.metaLanguage,

  constUsers: state.app.constUserList,
  previousFilters: state.media.previousFilters,
  presetList: state.media.presetList.list,
  preMediaList: state.media.preMediaList.list,
  postMediaList: state.media.postMediaList.list,
  isMandatoryMetaFilled: state.media.isMandatoryMetaFilled,
  agenciesList: state.constants.agenciesList,
  usersList: state.users.userList,
  businessList: state.constants.businessList.list,
  productList: state.constants.productList.list,
  bunchBusinessList: state.constants.bunchBusinessList.list,
  bunchProductList: state.constants.bunchProductList.list,
  bunchBusinessListLoading: state.constants.bunchBusinessList.isLoading,
  bunchProductListLoading: state.constants.bunchProductList.isLoading,
  allHostsList: state.constants.allHostsList.list,
  defaultTeam: state.constants.defaultTeam,
  denmarkHosts:
    state.constants.allHostsList.list &&
    Array.isArray((state.constants.allHostsList.list as AllHostsList)?.hosts)
      ? (state.constants.allHostsList.list as AllHostsList)?.hosts
      : Array.isArray(state.constants.allHostsList.list)
        ? state.constants.allHostsList.list
        : [],
});

const mapDispatch = {
  getListMedia,
  getMedia,
  trimMedia,
  deleteMedia,
  setMediaDetails,
  updateIsFilter,
  updateIsClearFilter,
  updatePreviousFilters,
  getSearchedListMedia,
  getPresetList,
  setMediaList,
  emptyMediaDetails,
  emptyAssetDetails,
  getListAgencies,
  getListUser,
  getBunchListData,
  setIsMediaDetailForm,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector> & { limit?: number };
export default connector(MediaList);
